import type { FC } from "react";
import { FormProvider } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { MessagesDisplayContainer, TextboxTemplate } from "@ryde/controls";
import { formatPhoneLocal } from "@ryde/shared";
import {
  apiDataFetchingLandingAtom,
  isServerMessageHasError,
  landingInitDataAtom,
  landingMessagesAtom,
  VERIFICATION_CODE_PLACE_HOLDER,
  VerifyCodeStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepVerifyCodeClal } from "./use-step-verify-code.clal";

export const StepVerifyCodeClal: FC = () => {
  const { methods, handleCodeVerification, resendOtp, isContinueCanBeApply } =
    useStepVerifyCodeClal();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();
  const { supportCenterPhone } = useRecoilValue(landingInitDataAtom) ?? {};

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <div className="landing-top-illustration">
          <img src={RASTER_LANDINGS.CarFestImagePNG} alt="Car fest" />
        </div>
        <h1 className="landing-title">{t("landing.verifyCode.title")}</h1>
        <div className="landing-form-field">
          <label htmlFor={VerifyCodeStepFormFieldsEnum.VerificationCode}>
            {t("landing.formLabel.mailVerificationCode")}*
          </label>
          <TextboxTemplate
            uniqueAttrId={VerifyCodeStepFormFieldsEnum.VerificationCode}
            name={VerifyCodeStepFormFieldsEnum.VerificationCode}
            placeholder={VERIFICATION_CODE_PLACE_HOLDER}
          />
        </div>
        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />
        {isServerMessageHasError(landingMessages) && (
          <div className="landing-help-disclaimer">
            <Trans
              i18nKey="landing.verifyCode.errorWhileRequestOTPClal"
              values={{ phoneNumber: formatPhoneLocal(supportCenterPhone) }}
              components={{
                phone: (
                  <a
                    className="purple-link"
                    aria-label={formatPhoneLocal(supportCenterPhone)}
                    href={`tel:${supportCenterPhone}`}
                  />
                ),
              }}
            />
          </div>
        )}
        <ContinueButton
          disabled={!isContinueCanBeApply}
          onClick={handleCodeVerification}
          loading={isApiLoading}
        />
        <button
          type="button"
          className="purple-link pointer"
          onClick={resendOtp}
        >
          {t("general.sendMeAgain")}
        </button>
        <div className="landing-container-footer">
          <div className="landing-container-footer-logo">
            <img
              className="landing-logo__img"
              src={RASTER_LANDINGS.RideLogoPNG}
              alt="Ryde logo"
              width="120"
              height="51"
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
